module.exports = __webpack_public_path__ + "img/手势识别--互动玩法--比枪gif.ba8a4b55.gif";